import {
    SSN_FETCH_STATUS_REQUEST, SSN_FETCH_STATUS_SUCCESS, SSN_FETCH_STATUS_ERROR,
    SSN_SET_FILTER, SSN_SET_SEARCH, SSN_SELECT_TARGETS,
    SSN_START_JOB_REQUEST, SSN_START_JOB_SUCCESS, SSN_START_JOB_CONFLICT, SSN_START_JOB_ERROR,
    SSN_POLL_JOB_TICK, SSN_JOB_TERMINAL, SSN_CLEAR_JOB,
    SSN_REFRESH_REQUEST, SSN_REFRESH_DONE
} from './types';

const initialState = {
    statusRows: [],
    selectedTargets: [],
    filter: 'all',
    searchTerm: '',
    runningJob: null,
    lastJobResult: null,
    loading: false,
    error: null,
    computedAt: null,
    isComputing: false,
    refreshing: false,
};

const ssnMigrationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SSN_FETCH_STATUS_REQUEST:
            return { ...state, loading: true, error: null };
        case SSN_FETCH_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                statusRows: payload.rows || [],
                computedAt: payload.computedAt || null,
                isComputing: payload.isComputing || false,
            };
        case SSN_REFRESH_REQUEST:
            return { ...state, refreshing: true };
        case SSN_REFRESH_DONE:
            return { ...state, refreshing: false };
        case SSN_FETCH_STATUS_ERROR:
            return { ...state, loading: false, error: payload };
        case SSN_SET_FILTER:
            return { ...state, filter: payload };
        case SSN_SET_SEARCH:
            return { ...state, searchTerm: payload };
        case SSN_SELECT_TARGETS:
            return { ...state, selectedTargets: payload };
        case SSN_START_JOB_REQUEST:
            return { ...state, error: null };
        case SSN_START_JOB_SUCCESS:
        case SSN_START_JOB_CONFLICT:
            return { ...state, runningJob: payload };
        case SSN_START_JOB_ERROR:
            return { ...state, error: payload };
        case SSN_POLL_JOB_TICK:
            return { ...state, runningJob: payload };
        case SSN_JOB_TERMINAL:
            return { ...state, runningJob: null, lastJobResult: payload };
        case SSN_CLEAR_JOB:
            return { ...state, runningJob: null, lastJobResult: null };
        default:
            return state;
    }
};

export default ssnMigrationReducer;
